<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Classification CIM10 </div>
        <div class="modal-body">
            <div class="all-container">
                <div class="search-result-container">
                    <div class="search">
                        <frg-search-input (search)="onSearchCIM10($event)"></frg-search-input>
                    </div>
                    <div *ngIf="!cim10BodyTable || cim10BodyTable.objects.length === 0">
                        Aucune spécialité médicamenteuse trouvée. Veuillez saisir ou modifier la recherche.
                    </div>
                    <div class="table">
                        <frg-table [keysBody]="cim10BodyTable" [keysColumn]="cim10ColumnTable" [isRowsClickable]="true"
                            (onClickRow)="selectedCim10($event)" [loading]="isLoadingCim10">
                        </frg-table>
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeSearchCim10()" [backgroundColor]="'var(--darkest-primary)'">Annuler
                </frg-button>
                <frg-button [backgroundColor]="'var(--primary)'" (activated)="closeSearchCim10(selectedCodeCim10)">
                    Valider</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>